"use client";
import React, { memo, useState } from "react";
import { AppModal } from "@/common";
import { Box } from "@mui/material";
import { AppModalProps } from "@/models";
import AppButton, { AppButtonProps } from "./AppButton";

const AppConfirmModal = ({
  onClose,
  onCancel,
  onConfirm,
  labelCancel = "Đóng",
  labelConfirm = "Xác nhận",
  labelConfirming = "Đang gửi ...",
  buttonConfirmProps,
  buttonCancelProps,
  ...otherProps
}: AppConfirmModalProps) => {
  const [isConfirming, setIsConfirming] = useState(false);
  const handleConfirm = async () => {
    setIsConfirming(true);
    const confirm = onConfirm();
    if (confirm instanceof Promise) {
      await confirm;
    }
    setIsConfirming(false);
    onClose();
  };

  return (
    <AppModal
      onClose={onClose}
      footer={
        <Box className="gap-3 flex items-center justify-between w-full">
          <AppButton
            variant="outlined"
            color="normal"
            onClick={onCancel}
            className="w-full"
            {...buttonCancelProps}
          >
            {labelCancel}
          </AppButton>
          <AppButton
            onClick={handleConfirm}
            variant="contained"
            color="primary"
            className="w-full"
            disabled={isConfirming}
            {...buttonConfirmProps}
          >
            {isConfirming ? labelConfirming : labelConfirm}
          </AppButton>
        </Box>
      }
      {...otherProps}
    />
  );
};

type AppConfirmModalProps = AppModalProps & {
  labelCancel?: string;
  labelConfirm?: string;
  labelConfirming?: string;
  buttonConfirmProps?: Omit<AppButtonProps, "ref">;
  buttonCancelProps?: Omit<AppButtonProps, "ref">;
  onCancel: () => void;
  onConfirm: () => void | Promise<void>;
};

export default memo(AppConfirmModal);
